import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import OrderList from '../../Shop/Orders/OrdersList';

function OrderSelectModal({ show, onHide, eventID, selectedOrder, onSelectOrder, selected }) {
    const { t } = useTranslation();

    return (
        <Modal
            show={show}
            onHide={onHide}
            size="xl"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    {t('orders.selected_order')}:&nbsp;
                    <>
                        {selected ?
                            <>{selected.name} ({selected.orderNumber})</>
                        : null}
                    </>
                </Modal.Title>
            </Modal.Header>
            <OrderList
                asOrderSelect
                selectedOrder={selectedOrder}
                onSelectOrder={onSelectOrder}
                eventID={eventID}
                limit={25}
            />
            <Modal.Footer>
                <Button
                    type="button"
                    variant="default"
                    onClick={onHide}
                >
                    {t('general.close')}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default OrderSelectModal;
